import { Radius as BaseRadius } from './Border';
import * as ThemeColor from './Color';
import * as BaseSizes from './Size';
import { Size as BaseSpacing } from './Spacing';

export enum Size {
  Small = BaseSizes.X2Large,
  Medium = BaseSizes.X4Large,
}
export enum Radius {
  Small = BaseRadius.XSmall,
  Medium = BaseRadius.Medium,
}

export const Spacing = {
  Small: [BaseSpacing.XXSmall + BaseSizes.X2Small], // +BaseSizes.X2Small to compensate for the border
  Medium: [BaseSpacing.XSmall, BaseSpacing.Small],
};

export const Variant = {
  Outline: {
    Color: {
      Background: ThemeColor.Neutrals.Paper,
      Border: ThemeColor.Neutrals.Border,
      Content: ThemeColor.Neutrals.Dark,
    },
    Hover: {
      Background: ThemeColor.Neutrals.Paper,
      Content: ThemeColor.Brand.Primary,
    },
  },
  Secondary: {
    Color: {
      Background: ThemeColor.Neutrals.Light,
      Content: ThemeColor.Neutrals.Dark,
    },
    Hover: {
      Background: ThemeColor.Brand.Primary,
      Content: ThemeColor.Brand.Primary,
    },
  },
};
